import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button, Grid, Input, Table, Select, Image, Message, Container, Modal, Dimmer } from 'semantic-ui-react';
import { ITechnicianCertificatePhoto } from '../../../app/models/techniciancertificatephoto';
import TechnicianCertificateStore from '../../../app/stores/techniciancertificateStore';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../../app/stores/rootStore';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { Link } from 'react-router-dom';
import CertificatePhotoDropzone from '../../../app/common/Dropzone/CertificatePhotoDropzone';

interface IProps {
  certificate: string;
  name: string;
  technicianEmail: string;
  certificateId: string;

}

const PhotoView: React.FC<IProps> = ({ certificate, name, technicianEmail, certificateId }) => {
  const rootStore = useContext(RootStoreContext);
  const {closeModal, openModal} = rootStore.modalStore;
  const technicianCertificateStore = useContext(TechnicianCertificateStore);
  const {
    loadTechnicianCertificatePhoto,
    techniciancertificatephotosById,
    deleteTechnicianCertificatePhoto,
    target,
    submitting,
  } = technicianCertificateStore;

  const [active, setDimmer] = useState({
    gridid: '',
    status: false
  });

  return (
          <Grid  columns='equal' celled>
            { (techniciancertificatephotosById.length !== 0) ?
            techniciancertificatephotosById.map((techniciancertificatephoto) => (
               <Grid.Column key={techniciancertificatephoto.id}>
                 {techniciancertificatephoto.path.replace(/^.*[\\\/]/, '')}
                {/* <Image
        src={`${techniciancertificatephoto.url}`}
        size='medium'
      />  
      <Button
                  as="a"
                  href={`${techniciancertificatephoto.url}`}
                  download
                  size='mini'
                  content="download"
                  color="blue"

                />
                <Button
                  name={techniciancertificatephoto.id}
                  loading={target === techniciancertificatephoto.id && submitting}
                  size='mini'
                  onClick={() =>  deleteTechnicianCertificatePhoto(techniciancertificatephoto.id).then(
                    () => openModal(<PhotoView certificate={certificate} name={name} technicianEmail={technicianEmail} certificateId={certificateId}/>))}
                  color="red"
                  content="Delete"
                /> */}


      <Dimmer.Dimmable
      //  as={Container}
      dimmed={active.status}
      // dimmer={{ active }}
      onMouseEnter={() => setDimmer({['gridid']: techniciancertificatephoto.id, ['status']: true })}
      onMouseLeave={() => setDimmer({['gridid']: techniciancertificatephoto.id, ['status']: false })}
      // size='medium'
      // src={`${techniciancertificatephoto.url}`}
    >
      <Image src={(techniciancertificatephoto.url.split('.')[1].toUpperCase() === "JPG" || 
      techniciancertificatephoto.url.split('.')[1].toUpperCase() === "JPEG" ||
      techniciancertificatephoto.url.split('.')[1].toUpperCase() === "PNG") ? 
                    `${techniciancertificatephoto.url}` :
                   "/assets/placeholder.png"} size='medium'/>
      <Dimmer active={(active.gridid === techniciancertificatephoto.id) && active.status}>
      <Button
                   as="a"
                  href={`${techniciancertificatephoto.url}`}
                  target="_Blank"
                   size='mini'
                   content="Preview"
                   color="green"

                 />
    <Button
                   as="a"
                  href={`${techniciancertificatephoto.url}`}
                   download
                   size='mini'
                   content="Download"
                   color="blue"

                 />
                 <Button
                  name={techniciancertificatephoto.id}
                  loading={target === techniciancertificatephoto.id && submitting}
                  size='mini'
                  onClick={() =>  deleteTechnicianCertificatePhoto(techniciancertificatephoto.id).then(
                    () => openModal(<PhotoView certificate={certificate} name={name} technicianEmail={technicianEmail} certificateId={certificateId}/>))}
                  color="red"
                  content="Delete"
                />
                 </Dimmer>
    </Dimmer.Dimmable>
    </Grid.Column>
            )) 
            : <Message>No Certificate Photo Uploaded</Message>
           }
      
         </Grid>
 
  );
};

export default PhotoView;
